import { useTenant } from '@/hooks/use-tenant';
import { IntegrationRequiredCard } from '@/components/integration-required-card';
import {
  CampaignHeader,
  CampaignLayout,
  CampaignMainContent,
} from '@/layouts/campaign.layout';

export function RequireIntegrationLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const tenant = useTenant();

  if (tenant.isStoreIntegrationConfigured) {
    return children;
  }

  return (
    <CampaignLayout>
      <CampaignHeader backTo="../" title="" />
      <CampaignMainContent>
        <IntegrationRequiredCard />
      </CampaignMainContent>
    </CampaignLayout>
  );
}
